module.exports = __webpack_public_path__ + "static/media/R.367c9d14.png";